import React, { useEffect, useState } from "react";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import { FiSearch } from "react-icons/fi";
import DeleteModal from "../../commonComponent/DeleteModal";
import { getDoctors } from "../../services/DoctorService";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import {
  getCareTeamsforAdmin,
  updateCareTeamStatusAdmin,
} from "../../services/CareTeam";

const TeamMemberList = ({ teamData1 }) => {
  const providerId = JSON.parse(localStorage.getItem("user_id"));
  const [memberList, setMemberList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [memberRequestList, setMemberRequestList] = useState([]);
  const [teamData, setTeamData] = useState();


  const getCareTeamById = async () => {
    try {
      const response = await getCareTeamsforAdmin();
      if (response.status !== 200) return;
      setTeamData(
        response.data.data.filter((team) => team._id === teamData1._id)[0]
      );
      getAllMemberList( response.data.data.filter((team) => team._id === teamData1._id)[0])
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(()=>{
    getCareTeamById()
  },[])

  const onChangeSearchText = (e) => {
    let searchTerm = e.target.value;

    const result = filteredData.filter((member) =>
      member.full_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (searchTerm === "") {
      setMemberList(filteredData);
    } else {
      setMemberList(result);
    }
  };

  const getAllMemberList = async (teamData) => {
    try {
      const result = await getDoctors();

      if (result.status !== 200) return;
      let filteredMembers =
        result.data.data.filter((member) =>
          teamData.teamMeambers.some(
            (teamMember) =>
              teamMember._id === member._id && teamMember.status === "accept"
          )
        ) ?? false;
      let filteredRequest =
        result.data.data.filter((member) =>
          teamData.teamMeambers.some(
            (teamMember) =>
              teamMember._id === member._id && teamMember.status === "rejoin"
          )
        ) ?? false;
      setMemberList(filteredMembers);
      setMemberRequestList(filteredRequest);
      setFilteredData(filteredMembers);
    } catch (error) {
      console.log(error);
    }
  };


  const handleChangeStatus = async (id, status, member) => {
    try {
      let payload = {
        careTeamId: id,
        teamMemberId: member,
        status: status,
      };
      const response = await updateCareTeamStatusAdmin(payload);

      if (response.status !== 200) {
        showToastError("Something went wrong");
        return;
      }
      showToastSuccess(
        status === "accept" ? "Team request accepted" : "Team request decline"
      );
      getCareTeamById()
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="d-flex mt-4 mb-4">
        <div className="w-100">
          <div className="actsearch_simple shadow-sm me-2">
            <FiSearch className="boxicon" />
            <input
              placeholder="Search Care Team Member Name here..."
              className="ms-2"
              onChange={(e) => onChangeSearchText(e)}
            />
          </div>
        </div>
      </div>
      <div>
        <Tabs className="mt-2">
          <TabList>
            <Tab>
              <span className="resFont">My Members</span>
            </Tab>
            {(teamData?.teamManager === providerId ||
              teamData?.docId === providerId) && (
              <Tab>
                <span className="resFont">Member Request</span>
              </Tab>
            )}
          </TabList>
          <TabPanel>
            <table class="table table-hover" style={{ marginTop: "-20px" }}>
              <thead>
                <tr>
                  <td className="py-4" scope="col text-secondary">
                    Team Member Name
                  </td>
                  <td className="py-4" scope="col text-secondary">
                    Role
                  </td>
                  <td className="py-4" scope="col text-secondary">
                    Group
                  </td>
                  <td className="py-4" scope="col text-secondary">
                    Program
                  </td>
                  <td className="py-4" scope="col text-secondary">
                    Status
                  </td>
                </tr>
              </thead>
              <tbody>
                {memberList.map((member) => (
                  <tr key={member._id}>
                    <td className="text-muted">
                      <SquareAvatar
                        src={"images/avatar.png"}
                        className="member_listimage squre_image2"
                      />
                      <span className="ms-3">{member.full_name}</span>
                    </td>
                    <td className="text-muted">{member.role}</td>
                    <td className="text-muted">Diabetes management</td>
                    <td className="text-muted">EDVA</td>
                    <td
                      className="text-success cursor-pointer"
                      data-bs-toggle="modal"
                      data-bs-target="#deactivategroup"
                    >
                      {member.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TabPanel>
          {(teamData?.teamManager === providerId ||
            teamData?.docId === providerId) && (
            <TabPanel>
              {memberRequestList.map((member) => (
                <div
                  key={member._id}
                  className="d-flex justify-content-between "
                >
                  <div className="text-muted">
                    <SquareAvatar
                      src={"images/avatar.png"}
                      className="member_listimage squre_image2"
                    />
                    <span className="ms-3">{member.full_name}</span>
                  </div>
                  <div className="text-muted">{member.role}</div>
                  <div>
                    <>
                      <button
                        className="btn btn-success me-2"
                        onClick={() =>
                          handleChangeStatus(teamData._id, "accept", member._id)
                        }
                      >
                        Accept
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() =>
                          handleChangeStatus(teamData._id, "cancel", member._id)
                        }
                      >
                        Decline
                      </button>
                    </>
                  </div>
                </div>
              ))}
            </TabPanel>
          )}
        </Tabs>
      </div>

      <DeleteModal
        title={"Delete"}
        content1={"Are you sure you want to deactivate"}
        content2={"this group?"}
        modalId={"deactivategroup"}
        button2={"No"}
        button1={"Yes"}
      />
    </>
  );
};

export default TeamMemberList;
